'use client';

import ContactHero from './ContactHero';
import ContactSections from './ContactSections';
import type { ContactPageData } from '@/types/contact';
import type { LeadForm } from '@/types/lead-forms';

interface ContactPageViewProps {
  data: ContactPageData;
  leadForms: LeadForm[];
}

export default function ContactPageView({ data, leadForms }: ContactPageViewProps) {
  return (
    <div className="font-figtree text-[#1C1917] antialiased">
      <ContactHero data={data} />
      <ContactSections components={data.components ?? []} leadForms={leadForms} />
    </div>
  );
}
